import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { connect } from 'dva';
import styles from './index.less';
import CitysPart from './components/citysPart';
import api from '@/common/api';
import CinemaListPart from './components/cinemaList';
import SelectPart from './components/selectPart';
import {
  getQueryString
} from '@/utils/index';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';
const nodata = require('./imgs/nodata@2x.png');
const MovieList = (props) => {
  const [cityList, setCityList] = useState<string[]>([]);
  const [regionList, setRegionList] = useState<string[]>([]);
  const [cinemaList, setCinemaList] = useState(null);
  const [currentCity, setCurrentCity] = useState('');
  const [currentRegion, setCurrentRegion] = useState('全部区域');
  const [errorTips, setErrorTips] = useState('');
  const [showCityModal, setShowCityModal] = useState(false);
  const [showTips, setShowTips] = useState(true);
  const [loading, setLoading] = useState(true);
  const [showSelectModal, setShowSelectModal] = useState(0);
  const [price, setPrice] = useState(0);
  useEffect(() => {
    const cardNo = getQueryString('cardNo');
    if(!cardNo){
      window.df_sdk_common.location.replace('/newmovie/movieListdetail?type=nocard');
      return;
    }
    setLoading(true);
    api.getCitysOffLine({cardNo:cardNo}).then((data) => {
      if(!data?.body && data?.msg){
        if(data.code !== 223546){
          setErrorTips(data?.msg);
        }
      }else if (data) {
        setCityList(data?.cityList || []);
        setPrice(data?.price||0);
      }
      if(data.code !== 223544&&data.code !== 116001){
        setLoading(false);
      }
    });
    setTimeout(() => {
      setShowTips(false);
    }, 5000);
  }, []);
  useEffect(() => {
    if (cityList.length > 0) {
      DFWebUtilsTools.getLocationByIp({ modeType: 7 }).then((res: any) => {
        if (res?.Data?.code === 200) {
          const _ind = cityList.indexOf(res.Data.data.city.nameCh);
          if (_ind > -1) {
            setCurrentCity(res.Data.data.city.nameCh);
          } else {
            setShowCityModal(true);
            setShowTips(false);
          }
        } else {
          setShowCityModal(true);
          setShowTips(false);
        }
      });
    }
  }, [cityList]);
  useEffect(() => {
    if (currentCity) {
      const params = {
        cityName: currentCity,
        regionName: currentRegion === '全部区域' ? '' : currentRegion,
        price:price
      };
      api.getCinemaOffLine(params).then((data) => {
        if (data?.regionList) {
          const defulatList = ['全部区域'];
          setRegionList([...defulatList, ...data?.regionList]);
          setCinemaList(data?.cinemas || null);
        } else {
          setRegionList([]);
          setCinemaList(null);
        }
      });
    }
  }, [currentCity, currentRegion]);

  const changeSelected = (name) => {
    if (showSelectModal === 1) {
      setCurrentCity(name);
      setCurrentRegion('全部区域');
    } else if (showSelectModal === 2) {
      setCurrentRegion(name);
    }
    setShowSelectModal(0);
  };

  return <div className={styles.cityList}>
    {showCityModal && <CitysPart data={cityList} callBack={(city) => { setCurrentCity(city); setShowCityModal(false); }}></CitysPart>}
    <div className={styles.headContent}>
      {!loading &&<div className={styles.headTitle}>
        <div className={styles.title}>影院列表</div>
        <div className={styles.subTitle}>现场购票可使用影院</div>
      </div>}
      {!showCityModal && cityList?.length > 0 && <div className={styles.selectBtns}>
        <div className={`${styles.selectBtn + ' ' + (showSelectModal === 1 ? styles.openSelect : '')}`} onClick={() => {
          showSelectModal !== 1 ? setShowSelectModal(1) : setShowSelectModal(0);
        }}
        >
          {currentCity}
          <div className={`${styles.selectIconOpen + ' ' + (showSelectModal === 1 ? styles.rotate : '')}`}></div>
        </div>
        {!showCityModal && <div className={`${styles.selectBtn + ' ' + (showSelectModal === 2 ? styles.openSelect : '')}`} onClick={() => {
          showSelectModal !== 2 ? setShowSelectModal(2) : setShowSelectModal(0);
        }}
                           >
          {currentRegion}
          <div className={`${styles.selectIconOpen + ' ' + (showSelectModal === 2 ? styles.rotate : '')}`}></div>
        </div>}
      </div>}
      {!showCityModal && cityList?.length > 1 && showTips&&
      <div  className={styles.tipsmsg}>该卡适用多城市，点击可切换城市</div>}
    </div>
    {!loading && !cinemaList&&!errorTips && <div className={styles.nodata}>
      <img src={nodata}></img>
      <div className={styles.tips}>
        <div>没有您的福利卡可以兑换的线下影院，</div>
        <div>请至线上购票</div>
        <div>
          <div className={styles.button} onClick={() => {window.df_sdk_common.location.replace('/newmovie');}}>去线上看看</div>
        </div>
      </div>
    </div>}
    {!loading && errorTips && <div className={styles.nodata}>
      <img src={nodata}></img>
      <div className={styles.tips}>
        <div>{errorTips}</div>
      </div>
    </div>}
    {cinemaList && <CinemaListPart data={cinemaList}></CinemaListPart>}
    {showSelectModal !== 0 && <SelectPart activeCity={currentCity} activeRegion={currentRegion} data={showSelectModal === 1 ? cityList : regionList} callBack={(e) => { changeSelected(e); }}></SelectPart>}
  </div>;
};
export default MovieList;
